<template>
  <div class="buydialog">
    <div class="dialogtext">
      <p>請與所在機構聯系獲取訪問權限</p>
      <p>或</p>
      <!-- 请与所在机构联系获取访问权限 或 购买会员卡畅读全库文献 -->
      <p><span class="linktext" @click="goaway">購買會員卡</span></p>
      <p>暢讀全庫文獻</p>

      <!-- <p>请与所在机构联系获取访问权限</p>
        <p>或</p>
        <p><span class="linktext">购买会员卡</span>畅读全库文献</p> -->
    </div>
  </div>
</template>

<script>
import eventBus from "@/utils/eventBus.js"
export default {
  name: "BuyConfirm",
  data () {
    return {
      // buyVisible: true,
    }
  },
  // props: ['buyVisible'],
  methods: {
    goaway () {
      eventBus.$emit("changeBuy", false)
      // let curpatharr = window.location.href.split("/")
      // let gopath = curpatharr[0] + '//' + curpatharr[2] + '/#/products'

      // window.open('#/products', "_blank")
      const url = this.$router.resolve('/products').href // 获取完整的URL
      window.open(url, '_blank') // 在新窗口中打开

    },


  }

}
</script>

<style lang="less" scoped>
.buydialog {
  width: 100%;
  // min-width: 500px;
  height: 465px;
  border-radius: 20px;
  background: url(/static/login/loginboxbg.png) no-repeat;
  background-size: auto 465px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .dialogtext {
    line-height: 1.6;
    p {
      margin: 0;
    }
    float: right;
    width: 70%;
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    color: #a0a0a0;
    // color: #959595;
    // font-family: "FangZheng-FanTi-Kaiti", STKaiti, serif;
    font-family: KaiTi, STKaiti, serif;
    .linktext {
      cursor: pointer;
      color: #9b0000;
      font-size: 47px;
      display: block;
      width: 250px;
      border-bottom: 1px solid #a0a0a0;
      // text-decoration: underline;
      margin: 0 auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/buyconfirm.vue